/**
 * Localizes the aria-labels of Glider pagination dots based on the document language.
 * Expects the Glider dots to live within the closest `.slider` parent
 *
 * @param {Element} sliderEl - The element that initialized Glider and emitted the event.
 */
function localizeGliderPagination(sliderEl) {
  const lang = document.documentElement.lang || 'en';
  const labelPrefix = lang.startsWith('de') ? 'Seite' : 'Page';

  const parentSliderEl = sliderEl.closest('.slider');
  if (!parentSliderEl) return;

  const dots = parentSliderEl.querySelectorAll('.glider-dot');
  if (!dots.length) return;

  dots.forEach((dot, index) => {
    dot.setAttribute('aria-label', `${labelPrefix} ${index + 1}`);
  });

  sliderEl.dispatchEvent(
    new CustomEvent('toujou-slider-dots-localized', {
      bubbles: true,
      composed: true,
      detail: { sliderEl },
    }),
  );
}

/**
 * Localize Glider pagination dots once it has been loaded
 */
document.addEventListener('glider-loaded', (event) => {
  if (!(event.target instanceof Element)) return;

  localizeGliderPagination(event.target);
});
